export { default } from './MainSlider';
